import React from 'react';
import {
  Button, Row, Col, Form, Collapse,
} from 'react-bootstrap';
import { BsPlusCircleFill } from 'react-icons/bs';
import '../style/style.css';
import PropTypes from 'prop-types';
import notFoundImage from '../not-found-image.png';
import {
  addNews, updateNews, deleteNews, updateNewsFile,
} from '../services/News';
import { getContent } from '../api';
import DeleteModal from './Modal';
import SuccessMessage from './SuccessMessage';

/* eslint no-underscore-dangle: 0 */
/* eslint-disable prefer-template */
function orderNewsList(List) {
  return List.sort((a, b) => new Date(b.date) - new Date(a.date));
}

let succeed = true;

class NewsEdit extends React.Component {
  constructor(props) {
    super(props);
    const { News } = this.props;
    this.state = {
      open: false,
      titleEs: null,
      titlePt: null,
      link: null,
      date: null,
      image: null,
      newsList: orderNewsList(News),
      showModal: false,
      idModal: '',
      titleModal: '',
      error: null,
      showToast: false,
      message: '',
    };
  }

  setShow = (value) => {
    this.setState({ showToast: value });
  };

  setMessage = (value) => {
    this.setState({ message: value });
  };

  handleClose = () => {
    this.setState({ showModal: false });
  };

  handleShow = (id, title) => {
    this.setState({ showModal: true });
    this.setState({ idModal: id });
    this.setState({ titleModal: title });
  };

  handleDelete = () => {
    const { idModal } = this.state;
    deleteNews(idModal)
      .catch((err) => {
        succeed = false;
        document.getElementById(idModal).textContent = err.response.data.message;
      })
      .then(() => {
        if (succeed) {
          this.updateNewsList();
          document.getElementById(idModal).textContent = null;
          this.setShow(false);
          this.setShow(true);
          this.setMessage('Notícia eliminada com sucesso!');
        }
      });
    this.setState({ showModal: false });
  };

  setOpen() {
    const { open } = this.state;
    if (!open) document.getElementById('new-news').reset();
    this.setState({ open: !open });
  }

  setTitleEs(value) {
    this.setState({ titleEs: value });
  }

  setTitlePt(value) {
    this.setState({ titlePt: value });
  }

  setLink(value) {
    this.setState({ link: value });
  }

  setDate(value) {
    this.setState({ date: value });
  }

  setImage(value) {
    this.setState({ image: value });
  }

  setNewsList(value) {
    this.setState({ newsList: orderNewsList(value) });
  }

  setError(value) {
    this.setState({ error: value });
  }

  insertNews = (e) => {
    e.preventDefault();
    // delete next line when updload file succed
    succeed = true;
    const {
      titlePt, titleEs, link, image, date,
    } = this.state;
    if (image === null) {
      this.setError('Insira uma imagem!');
      return;
    }
    addNews(titlePt, titleEs, link, image, date)
      .catch((err) => {
        succeed = false;
        this.setError(err.response.data.message);
      })
      .then(() => {
        if (succeed) {
          this.setState({ open: false });
          e.target.closest('form').reset();
          this.setError(null);
          this.updateNewsList();
          this.setShow(false);
          this.setShow(true);
          this.setMessage('Notícia adicionada com sucesso!');
        }
      });
  };

  editNews = async (e) => {
    succeed = true;
    e.preventDefault();
    const form = e.target.closest('form');
    if (form === null) return;

    const id = form.dataset.reactid;
    const formTitlePt = document.querySelector(
      `[data-reactid='${id}'] .edit-news-title-pt`,
    );
    const formTitleEs = document.querySelector(
      `[data-reactid='${id}'] .edit-news-title-es`,
    );
    const formLink = document.querySelector(
      `[data-reactid='${id}'] .edit-news-link`,
    );
    const formDate = document.querySelector(
      `[data-reactid='${id}'] .edit-news-date`,
    );
    const formImage = document.querySelector(
      `[data-reactid='${id}'] .edit-news-image`,
    ).files[0];

    if (
      formTitlePt.value === formTitlePt.defaultValue
      && formTitleEs.value === formTitleEs.defaultValue
      && formLink.value === formLink.defaultValue
      && formDate.value === formDate.defaultValue
      && formImage === undefined
    ) return;

    if (formImage === undefined) {
      updateNews(
        id,
        formTitlePt.value,
        formTitleEs.value,
        formLink.value,
        'blob',
        formDate.value,
      )
        .catch((err) => {
          succeed = false;
          document.getElementById(id).textContent = err.response.data.message;
        })
        .then(() => {
          if (succeed) {
            formTitlePt.defaultValue = formTitlePt.value;
            formTitleEs.defaultValue = formTitleEs.value;
            formLink.defaultValue = formLink.value;
            formDate.defaultValue = formDate.value;
            document.getElementById(id).textContent = null;
            this.setShow(false);
            this.setShow(true);
            this.setMessage('Notícia editada com sucesso!');
          }
        });
    } else {
      updateNewsFile(
        id,
        formTitlePt.value,
        formTitleEs.value,
        formLink.value,
        formImage,
        formDate.value,
      )
        .catch((err) => {
          succeed = false;
          document.getElementById(id).textContent = err.response.data.message;
        })
        .then(() => {
          if (succeed) {
            formTitlePt.defaultValue = formTitlePt.value;
            formTitleEs.defaultValue = formTitleEs.value;
            formLink.defaultValue = formLink.value;
            formDate.defaultValue = formDate.value;
            document.getElementById(id).textContent = null;
            this.setShow(false);
            this.setShow(true);
            this.setMessage('Notícia editada com sucesso!');
          }
        });
    }
  };

  resetNews = async (e) => {
    e.preventDefault();
    const form = e.target.closest('form');
    const id = form.dataset.reactid;

    if (form === null) return;
    form.reset();
    document.getElementById(id).textContent = null;
  };

  updateNewsList = () => {
    getContent().then((res) => {
      this.setState({ newsList: orderNewsList(res.data.news) });
    });
  };

  render() {
    const {
      open,
      newsList,
      idModal,
      showModal,
      titleModal,
      error,
      showToast,
      message,
    } = this.state;
    return (
      <div className="section-edit" id="editar-notícias">
        <Row className="d-flex align-items-center justify-content-between">
          <Col className="col-10 d-flex flex-column">
            <h2 className="title my-auto">Editar Notícias</h2>
          </Col>
          <Col className="col-2 d-flex flex-column ps-0">
            <BsPlusCircleFill
              onClick={() => this.setOpen()}
              aria-controls="collapse-new-news"
              aria-expanded={open}
              className="edit-icon ms-auto ps-0"
              color="#C4C4C4"
              size="70px"
              id="plus-circle-news"
              title="Adicionar Notícia"
            />
          </Col>
        </Row>
        <hr className="edit-divider" />
        <div className="edit-card">
          <Collapse in={open}>
            <div id="collapse-new-service">
              <Form id="new-news">
                <Form.Group as={Row} className="mb-3 d-flex align-items-center">
                  <Form.Label column sm="2" className="card-label">
                    Título em Português
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control
                      as="textarea"
                      id="edit-new-title-pt"
                      rows={1}
                      style={{ resize: 'none' }}
                      placeholder="Adicione Título da Notícia em Português"
                      onChange={(e) => {
                        this.setTitlePt(e.target.value);
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3 d-flex align-items-center">
                  <Form.Label column sm="2" className="card-label">
                    Título em Espanhol
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control
                      as="textarea"
                      id="edit-new-title-es"
                      rows={1}
                      style={{ resize: 'none' }}
                      placeholder="Adicione Título da Notícia em Espanhol"
                      onChange={(e) => {
                        this.setTitleEs(e.target.value);
                      }}
                    />
                  </Col>
                </Form.Group>
                <div className="grid-news">
                  <div className="grid-news-link">
                    <Row className="grid-news-link-row d-flex align-items-center pt-3">
                      <Form.Label column sm={2} className="card-label">
                        Link
                      </Form.Label>
                      <Col sm={10} className="d-flex flex-column">
                        <Form.Control
                          as="textarea"
                          id="edit-new-link"
                          rows={1}
                          style={{ resize: 'none' }}
                          placeholder="Adicione Link da Notícia"
                          onChange={(e) => {
                            this.setLink(e.target.value);
                          }}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="grid-news-date">
                    <Row className="d-flex align-items-center">
                      <Form.Label column sm={2} className="card-label">
                        Data
                      </Form.Label>
                      <Col sm={10} className="d-flex flex-column">
                        <Form.Control
                          type="date"
                          id="edit-new-date"
                          rows={1}
                          style={{ resize: 'none' }}
                          placeholder="Adicione Data da Notícia"
                          onChange={(e) => {
                            this.setDate(e.target.value);
                          }}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="grid-news-photo edit-card-pad">
                    <img
                      id="upload-news-image"
                      src={notFoundImage}
                      alt="imagem da notícia"
                      width="235px"
                      height="162px"
                    />
                    <div className="upload-image-div">
                      <label className="upload-image-text custom-file-upload">
                        <input
                          type="file"
                          onChange={(e) => {
                            this.setImage(e.target.files[0]);
                            document.getElementById('upload-news-image').src = URL
                              .createObjectURL(e.target.files[0]);
                          }}
                        />
                        Adicionar Imagem
                      </label>
                    </div>
                  </div>
                </div>
                <div>
                  <small id="0" className="text-danger pre-wrap">
                    {error}
                  </small>
                </div>
                <div className="d-flex justify-content-md-start justify-content-center">
                  <Button
                    onClick={(e) => this.insertNews(e)}
                    variant="principal btn-custom"
                  >
                    Guardar alterações
                  </Button>
                  <Button
                    onClick={(e) => this.resetNews(e)}
                    variant="cancel btn-custom"
                  >
                    Cancelar
                  </Button>
                </div>
              </Form>
              <hr className="edit-divider divider-card" />
            </div>
          </Collapse>
        </div>
        <div id="div-map" className="edit-card">
          {newsList.map((news) => (
            <Form data-reactid={news._id} key={news._id}>
              <Form.Group as={Row} className="mb-3 d-flex align-items-center">
                <Form.Label column sm="2" className="card-label">
                  Título em Português
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    as="textarea"
                    className="edit-news-title-pt"
                    rows={1}
                    style={{ resize: 'none' }}
                    defaultValue={news.title1.pt}
                    placeholder="Adicione Título da Notícia em Português"
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3 d-flex align-items-center">
                <Form.Label column sm="2" className="card-label">
                  Título em Espanhol
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    as="textarea"
                    className="edit-news-title-es"
                    rows={1}
                    style={{ resize: 'none' }}
                    defaultValue={news.title1.es}
                    placeholder="Adicione Título da Notícia em Espanhol"
                  />
                </Col>
              </Form.Group>
              <div className="grid-news">
                <div className="grid-news-link">
                  <Row className="grid-news-link-row d-flex align-items-center pt-3">
                    <Form.Label column sm={2} className="card-label">
                      Link
                    </Form.Label>
                    <Col sm={10} className="d-flex flex-column">
                      <Form.Control
                        as="textarea"
                        className="edit-news-link"
                        rows={1}
                        style={{ resize: 'none' }}
                        defaultValue={news.link}
                        placeholder="Adicione Link da Notícia"
                      />
                    </Col>
                  </Row>
                </div>
                <div className="grid-news-date">
                  <Row className="d-flex align-items-center">
                    <Form.Label column sm={2} className="card-label">
                      Data
                    </Form.Label>
                    <Col sm={10} className="d-flex flex-column">
                      <Form.Control
                        type="date"
                        className="edit-news-date"
                        rows={1}
                        style={{ resize: 'none' }}
                        defaultValue={news.date}
                        placeholder="Adicione Data da Notícia"
                      />
                    </Col>
                  </Row>
                </div>
                <div className="grid-news-photo edit-card-pad">
                  <img
                    id={news._id}
                    className="news-image"
                    value={news.image}
                    src={`${process.env.REACT_APP_API_URI}/api/image/${news.image}`}
                    alt="imagem da notícia"
                    width="235px"
                    height="162px"
                  />
                  <div className="upload-image-div">
                    <label className="upload-image-text custom-file-upload">
                      <input
                        className="edit-news-image"
                        type="file"
                        onChange={(e) => {
                          e.preventDefault();
                          document.getElementById(news._id).src = URL
                            .createObjectURL(e.target.files[0]);
                        }}
                      />
                      Alterar Imagem
                    </label>
                  </div>
                </div>
              </div>
              <p>
                <small id={news._id} className="text-danger pre-wrap">
                  {' '}
                </small>
              </p>
              <div className="d-flex justify-content-md-start justify-content-center">
                <Button
                  onClick={(e) => this.editNews(e, newsList)}
                  variant="principal btn-custom"
                >
                  Guardar alterações
                </Button>
                <Button
                  onClick={(e) => this.resetNews(e)}
                  variant="cancel btn-custom"
                >
                  Cancelar
                </Button>
                <Button
                  onClick={() => this.handleShow(news._id, news.title1.pt)}
                  variant="red btn-custom"
                >
                  Eliminar notícia
                </Button>
              </div>
              <hr className="edit-divider divider-card" />
            </Form>
          ))}
        </div>
        <DeleteModal
          id={idModal}
          show={showModal}
          handleClose={this.handleClose}
          handleDelete={this.handleDelete}
          title="Eliminar Notícia"
          body="Tem a certeza que pretende eliminar a notícia com o título "
          contentTitle={titleModal}
        />
        <SuccessMessage
          show={showToast}
          setShow={this.setShow}
          message={message}
        />
      </div>
    );
  }
}

NewsEdit.propTypes = {
  News: PropTypes.instanceOf(Object).isRequired,
};

export default NewsEdit;
